import { capitalizeFirstLetter } from "../helpers/capitalizeFirstLetter";
import { replaceCharacters } from "../helpers/replaceCharacters";
import { validation } from "../helpers/validation";
import { notification } from "../helpers/notification";
import {isSet} from "lodash/lang";
import {clearValidation} from "../helpers/clearValidation";
import {
    consumeSessionExpiredNotification,
    redirectToLoginWithSessionExpiredMessage,
} from "../helpers/session-expired";
$(document).ready(function () {
    function getBrowserTimezone() {
        try {
            return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
        } catch (error) {
            return '';
        }
    }

    function getCookieValue(name) {
        const escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const match = document.cookie.match(new RegExp('(?:^|; )' + escapedName + '=([^;]*)'));

        return match ? decodeURIComponent(match[1]) : null;
    }

    function syncAuthCsrfToken() {
        const cookieToken = getCookieValue('XSRF-TOKEN');

        if (!cookieToken) {
            return null;
        }

        $('meta[name="csrf-token"]').attr('content', cookieToken);
        $('input[name="_token"]').val(cookieToken);

        return cookieToken;
    }

    syncAuthCsrfToken();

    const authNotification = $('.js-auth-notification').first();
    const sessionExpiredNotification = $('.js-session-expired-notification').first();

    if (authNotification.length) {
        notification(
            authNotification.data('type') || 'error',
            authNotification.data('title') || 'Something went wrong',
            authNotification.data('description') || ''
        );
    } else if (sessionExpiredNotification.length) {
        notification(
            'error',
            sessionExpiredNotification.data('title'),
            sessionExpiredNotification.data('description')
        );
    } else {
        const storedSessionExpiredNotification = consumeSessionExpiredNotification();

        if (storedSessionExpiredNotification) {
            notification(
                storedSessionExpiredNotification.type || 'error',
                storedSessionExpiredNotification.message || 'Your session has expired.',
                storedSessionExpiredNotification.description || 'Please sign in again to continue.'
            );
        }
    }

    $(window).on('focus pageshow', function () {
        syncAuthCsrfToken();
    });

    $(document).on('visibilitychange', function () {
        if (document.visibilityState === 'visible') {
            syncAuthCsrfToken();
        }
    });

    $(document).on('submit', '#login-form, #admin-login-form', function () {
        syncAuthCsrfToken();
        const timezone = getBrowserTimezone();

        if (timezone) {
            $(this).find('input[name="timezone"]').val(timezone);
        }
    });

    $(document).on('submit', '#set-up-password-form', function () {
        const timezone = getBrowserTimezone();

        if (timezone) {
            $(this).find('input[name="timezone"]').val(timezone);
        }
    });

    //$('#show-invite-video-reg').modal('show');
    let video = $('#show-invite-video');
    if (video.length > 0) {
        video.click();
    }
    $.validator.addMethod(
        "validDay",
        function (value, element) {
            let parts = value.split('/');
            if (parts[1]) {
                if (parseInt(parts[1]) > 31) {
                    return false;
                }
            }
            return true;
        }, 'Day cannot be more than 31.'
    );
    $.validator.addMethod(
        "validMonth",
        function (value, element) {
            let parts = value.split('/');
            if (parts[0]) {
                if (parseInt(parts[0]) > 12) {
                    return false;
                }
            }
            return true;
        }, 'Month cannot be more than 12.'
    );
    $.validator.addMethod(
        "validYear",
        function (value, element) {
            let parts = value.split('/');
            if (parts[2]) {
                if (parseInt(parts[2]) <= 1910 || parseInt(parts[2]) >= 2007) {
                    return false;
                }
            }
            return true;
        }, 'The year must be greater than 1910 and less than 2007.'
    );
    $('#admin-login-form').validate({
        email: {
            required: true,
            email: true,
        },
        password: {
            required: true,
        },
    })
    $('#start-form').validate({
        email_or_phone: {
            required: true,
        },
    })
    $('#login-form').validate({
        email: {
            required: true,
            email: true,
        },
        password: {
            required: true,
        },
    })
    $('#set-up-password-form').validate({
        ignore: ":hidden:not(#salutation):not(#gender-select)",
        rules: {
            salutation: {
                required: {
                    depends: function () {
                        return $('#gender-select').length > 0;
                    },
                },
            },
            gender: {
                required: {
                    depends: function () {
                        return $('#gender-select').length > 0;
                    },
                },
            },
            first_name: {
                required: true,
                minlength: 2,
                maxlength: 255
            },
            last_name: {
                required: true,
                minlength: 2,
                maxlength: 255
            },
            phone_number: {
                minlength: 12,
                maxlength: 12,
                required: true,
            },
            password: {
                required: true,
                minlength: 15
            },
            password_confirmation: {
                minlength: 15,
                equalTo: "#password"
            },
            privacy_policy_consent: {
                required: {
                    depends: function () {
                        return $('#privacy-policy-consent').length > 0;
                    },
                },
            },
        },
        messages: {
            password_confirmation: {
                equalTo: 'You have entered 2 different passwords'
            },
        },
        invalidHandler: function (event, validator) {
            if (!validator || !validator.invalid || !validator.invalid.privacy_policy_consent) {
                return;
            }

            const form = $('#set-up-password-form');
            const url = form.data('consent-attempt-url');
            if (!url) {
                return;
            }

            $.ajax({
                url: url,
                method: 'POST',
                data: {
                    _token: $('meta[name="csrf-token"]').attr('content'),
                    unchecked_required_checkboxes: ['privacy_policy_consent'],
                },
            });
        },
        messages: {
            salutation: {
                required: 'This field is required.',
            },
            gender: {
                required: 'This field is required.',
            },
            phone_number: {
                minlength: 'Please enter at least 10 characters.',
                maxlength: 'Please enter no more than 10 characters.',
            },
            privacy_policy_consent: {
                required: 'You must accept Terms of Service, Privacy Policy, and RPM/PCM consent to continue.',
            },
        }
    })
    let dobSelect = $('.js-select-dob')
    dobSelect.on("focusout", function (e) {
        $(this).valid();
    });
    $('input').on("focusout", function (e) {
        $(this).valid();
    });

    //Select2 init
    let salutationSelect = $('.js-select-salutation');
    let genderSelect = $('.js-select-gender');
    let raceSelect = $('.js-select-race');
    salutationSelect.select2({
        width: '100%',
        minimumResultsForSearch: Infinity,
        placeholder: "Please select a salutation"
    });
    salutationSelect.on("select2:close", function () {
        $(this).valid();
    });
    salutationSelect.on("change", function () {
        if (! $(this).closest('#set-up-password-form').length) {
            return;
        }

        let mappedGender = {
            'Mr.': '0',
            'Ms.': '1',
            'Mrs.': '1',
            'Dr.': '3',
            'Mx.': '2',
        }[$(this).val()];

        if (mappedGender !== undefined) {
            genderSelect.val(mappedGender).trigger('change');
            genderSelect.valid();
        }
    });
    genderSelect.select2({
        width: '100%',
        minimumResultsForSearch: Infinity,
        placeholder: "Please select a gender"
    });
    genderSelect.on("select2:close", function (e) {
        $(this).valid();
    });
    raceSelect.select2({
        width: '100%',
        minimumResultsForSearch: Infinity,
        placeholder: "Please select a race"
    });
    raceSelect.on("select2:close", function (e) {
        $(this).valid();
    });
    //Datetimepicker select
    $(function () {
        let inputDob = $('.js-select-dob');
        $('#datetimepicker-view-mode').datetimepicker({
            viewMode: 'years',
            format: 'DD.MM.YYYY',
            date: moment(inputDob.val(), 'YYYY-MM-DD hh:mm a').toDate(),
            minDate: moment(inputDob.attr('min'), 'YYYY-MM-DD hh:mm a').toDate(),
            maxDate: moment(inputDob.attr('max'), 'YYYY-MM-DD hh:mm a').toDate(),
        });
    });

    $('b[role="presentation"]').hide();
    $('.select2-selection__arrow').append('<svg width="14px" height="14px" viewBox="0 0 16 16" class="bi bi-chevron-down" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n' +
        '  <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>\n' +
        '</svg>');
    //Select2 init end

    $('#dob').mask('00/00/0000')
    // $('#dob').mask('m0/d0/y000', {'translation': {
    //     m: {pattern: /[0-1]/},
    //     d: {pattern: /[0-3]/},
    //     y: {pattern: /[1-2]/},
    // }});

    $('#phone-number').mask('000-000-0000');
    $('#code').mask('000000');
    $('#mobile').mask('000-000-0000');
    $('.js-phone-number-mask').mask('000-000-0000');
    $("#approval-modal").on('shown.bs.modal', function () {
        $('.modal-backdrop').css('background', '#ff7f5d');
    });
    $("#approval-modal").on('hidden.bs.modal', function () {
        $('.modal-backdrop').css('background', '#ff7f5d');
    });
    $('#approval-modal').modal('show');
    $('.js-qualities-list').on('click', 'li', function (e) {
        e.preventDefault()
        let userQualities = $('#js-qualities-field').val().split(',').filter(i => i)
        let qualitieId = $(this).attr('data-id')
        let index = userQualities.indexOf(qualitieId);
        if (index > -1) {
            userQualities.splice(index, 1);
        } else {
            userQualities.push(qualitieId);
        }
        $('#js-qualities-field').val(userQualities.join(','))
        $(this).toggleClass('active-param')
    })
    let companyContainer = $('.js-company-name');
    let companyInput = $('.js-company-name-input');
    $('.js-find-company').on('change', function () {
        let element = $(this);
        let val = $(this).val();
        let url = $(this).data('url');
        $.ajax({
            url: url + '/' + val,
            method: "GET",
            success: function (response) {
                if (response.company) {
                    companyContainer.removeClass('d-none')
                    companyInput.val(response.company)
                    $(element).removeClass('is-invalid');
                } else {
                    $(element).removeClass('is-invalid');
                    companyContainer.addClass('d-none')
                    companyInput.val('')
                    if (response.status === 'error') {
                        $(element).addClass('is-invalid');
                        $(element).parent().closest('.form-group').find('.invalid-feedback strong').text(response.message);
                    }
                }
            },
            error: function (xhr) {
                let response = JSON.parse(xhr.responseText);
                notification('error', 'Something go wrong')
            }
        });
    })
    $(document).on('submit', '#start-form', function (e) {
        e.preventDefault()
        syncAuthCsrfToken();
        const timezone = getBrowserTimezone();

        if (timezone) {
            $('.js-browser-timezone').val(timezone);
        }

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        $.ajax({
            type: 'POST',
            url: $(this).attr('action'),
            data: {
                email_or_phone: $('#email-or-phone').val(),
            },
            success(response) {
                if (response.type === 'email') {
                    $("#login-form input[name=email]").val(response.email);
                    if (response.patient) {
                        $("#terms-patient").addClass('d-block')
                    } else {
                        $("#terms-owner").addClass('d-block')
                        $("#terms-patient").addClass('d-none')
                    }
                    $("#login-form").val(response.patient);
                    $('#start-form').addClass('d-none')
                    $('#login-form').removeClass('d-none')
                    $('#login-form-phone').addClass('d-none')
                    $('#login-form-code').addClass('d-none')
                } else if (response.type === 'phone') {
                    $('#start-form').addClass('d-none')
                    $('#login-form-phone').addClass('d-none')
                    $('#login-form-code').removeClass('d-none')
                    $('#login-form').addClass('d-none')
                    notification('success', 'Code sent successfully')
                } else if (response.type === 'error') {
                    $('#register-link').addClass('d-block')
                    $('#start-form').removeClass('d-none')
                    $('#login-form-phone').addClass('d-none')
                    $('#login-form-code').addClass('d-none')
                    $('#login-form').addClass('d-none')
                    notification('error', 'These credentials do not match our records.',
                        'Please try to login again')
                } else if (response.type === 'route-invite') {
                    location.href = response.route
                }
            },
            error(xhr) {
                redirectToLoginWithSessionExpiredMessage(xhr, '/login');
            }
        })
    })

    $(document).on('click', '.js-select-type-login', function (e) {
        e.preventDefault()
        const timezone = getBrowserTimezone();

        if (timezone) {
            $('.js-browser-timezone').val(timezone);
        }

        $('.is-invalid').removeClass('is-invalid')
        $('#code').val('')
        $('.login-btn-active').removeClass('login-btn-active')
        $(this).addClass('login-btn-active')
        if ($(this).attr('data-type') == 1) { //phone
            $('#start-form').addClass('d-none')
            $('#login-form').addClass('d-none')
            $('#login-form-phone').removeClass('d-none')
            $('#login-form-code').addClass('d-none')
        } else { //email
            $('#start-form').addClass('d-none')
            $('#login-form-phone').addClass('d-none')
            $('#login-form-code').addClass('d-none')
            $('#login-form').removeClass('d-none')
        }
    })
    $(document).on('click', '.js-select-type-login-admin', function (e) {
        e.preventDefault()
        $('#code').val('')
        $('.login-btn-active').removeClass('login-btn-active')
        $(this).addClass('login-btn-active')
        if ($(this).attr('data-type') == 1) {
            $('#admin-login-form').addClass('d-none')
            $('#admin-login-form-phone').removeClass('d-none')
            $('#admin-login-form-code').addClass('d-none')
        } else {
            $('#admin-login-form-phone').addClass('d-none')
            $('#admin-login-form-code').addClass('d-none')
            $('#admin-login-form').removeClass('d-none')
        }
    })

    $('#login-form-phone input[name="phone_number"]').on('change', function () {
        clearValidation($('#login-form-phone')[0])
    })
    $(document).on('submit', '#login-form-phone', function (e) {
        e.preventDefault()
        syncAuthCsrfToken();
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        $.ajax({
            type: 'POST',
            url: $(this).attr('data-url'),
            data: {
                phone_number: $('#phone-number').val(),
                timezone: getBrowserTimezone(),
            },
            success(response) {
                $('#login-form-phone').addClass('d-none')
                $('#login-form-code').removeClass('d-none')
                notification('success', 'Code sent successfully')
            },
            error(xhr) {
                if (redirectToLoginWithSessionExpiredMessage(xhr, '/login')) {
                    return;
                }

                let response = JSON.parse(xhr.responseText);
                validation($('#login-form-phone')[0], response.errors, true);
            }
        })
    })
    $(document).on('click', '.js-send-code', function (e) {
        e.preventDefault()
        syncAuthCsrfToken();
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        let phone = $('#phone-number').val()
        if (!phone) {
            phone = $('#email-or-phone').val()
        }
        $.ajax({
            type: 'POST',
            url: $(this).attr('data-url'),
            data: {
                phone_number: phone,
                code: $('#code').val(),
                timezone: getBrowserTimezone(),
            },
            success(response) {
                location.href = '/overview'
            },
            error(xhr) {
                if (redirectToLoginWithSessionExpiredMessage(xhr, '/login')) {
                    return;
                }

                let response = JSON.parse(xhr.responseText);
                validation($('#login-form-code')[0], response.errors, true);
            }
        })
    })
    $(document).on('click', '.js-resend-code', function (e) {
        syncAuthCsrfToken();
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        let phone = $('#phone-number').val()
        if (!$('#phone-number').val()) {
            phone = $('#email-or-phone').val()
        }
        $.ajax({
            type: 'POST',
            url: $('#login-form-phone').attr('data-url'),
            data: {
                phone_number: phone,
            },
            success(response) {
                notification('success', 'Code sent successfully')
            },
            error(xhr) {
                if (redirectToLoginWithSessionExpiredMessage(xhr, '/login')) {
                    return;
                }

                let response = JSON.parse(xhr.responseText);
                validation($('#login-form-phone')[0], response.errors, true);
            }
        })
    })

    $(document).on('submit', '#login-form-code', function (e) {
        e.preventDefault()
        syncAuthCsrfToken();
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        $.ajax({
            type: 'POST',
            url: $(this).attr('data-url'),
            data: {
                phone_number: $('#phone-number').val(),
                code: $('#code').val(),
                timezone: getBrowserTimezone(),
            },
            success(response) {
                location.href = '/overview'
            },
            error(xhr) {
                if (redirectToLoginWithSessionExpiredMessage(xhr, '/login')) {
                    return;
                }

                let response = JSON.parse(xhr.responseText);
                validation($('#login-form-code')[0], response.errors, true);
            }
        })
    })

    $(document).on('click', '.js-change-type-verify-to-email', function (e) {
        e.preventDefault()
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        $.ajax({
            type: 'GET',
            url: $(this).attr('data-url'),
            data: {
                type: $(this).attr('data-type'),
            },
            success(response) {
                location.href = '/email/verify'
            }
        })
    })
    $(document).on('click', '.js-change-type-verify-to-phone', function (e) {
        e.preventDefault()
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        $.ajax({
            type: 'GET',
            url: $(this).attr('data-url'),
            data: {
                type: $(this).attr('data-type'),
            },
            success(response) {
                location.href = '/email/verify'
            }
        })
    })
    $('#input-type').select2({
        width: '100%',
        minimumResultsForSearch: Infinity,
    });

    $(document).on('click', '.js-admin-login-phone', function (e) {
        syncAuthCsrfToken();
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            type: 'GET',
            url: $(this).attr('data-url'),
            data: {
                phone_number: $('#phone-number').val(),
            },
            success(response) {
                $('#admin-login-form-phone').addClass('d-none')
                $('#admin-login-form-code').removeClass('d-none')
            },
            error(response) {
                location.reload()
            }
        })
    })

    $(document).on('click', '.js-admin-send-code', function (e) {
        e.preventDefault()
        syncAuthCsrfToken();
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        $.ajax({
            type: 'GET',
            url: $(this).attr('data-url'),
            data: {
                phone_number: $('#phone-number').val(),
                code: $('#code').val(),
            },
            success(response) {
                location.href = '/admin/tests'
            },
            error(response) {
                location.reload()
            }
        })
    })


    $('.js-reload-page').on('click', function () {
        location.reload();
    });

    function checkEmailVerification() {
        if ($('.js-register-step[data-step=2]').is(':visible')) {
            $('body').addClass('no-loader');
            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });
            $.ajax({
                type: 'POST',
                url: $('.js-auth-container').data('url'),
                data: {},
                success(response) {
                    if (response) {
                        location.reload();
                    }
                },
                error(response) {
                    // location.reload()
                }
            })
            setTimeout(checkEmailVerification, 5000);
        }
    }

    checkEmailVerification();
})
